import React, { useState } from 'react';
import styled from '@emotion/styled';

export const Dropdown = ({
  trigger,
  children,
  align = 'left',
  className,
  block = false
}) => {
  const [open, setOpen] = useState(false);
  const close = () => setOpen(false);

  const isControlledByChild = typeof children === 'function';

  return (
    <Root className={className} $block={block}>
      <TriggerWrap $block={block} onClick={() => setOpen(o => !o)}>
        {trigger}
      </TriggerWrap>
      {open && (
        <>
          <Outside onClick={close} />
          <Panel $align={align} onClick={isControlledByChild ? undefined : close}>
            {isControlledByChild ? children({ close }) : children}
          </Panel>
        </>
      )}
    </Root>
  );
};

const Root = styled.div`
  position: relative;
  display: ${({ $block }) => ($block ? 'block' : 'inline-block')};
  ${({ $block }) => $block && 'width: 100%;'}
`;

const TriggerWrap = styled.span`
  display: ${({ $block }) => ($block ? 'flex' : 'inline-flex')};
  ${({ $block }) => $block && 'width: 100%;'}
`;

const Outside = styled.div`
  position: fixed;
  inset: 0;
  z-index: 40;
`;

const Panel = styled.div`
  position: absolute;
  top: calc(100% + 6px);
  ${({ $align }) => ($align === 'right' ? 'right: 0;' : 'left: 0;')}
  z-index: 50;
  background: ${({ theme }) => theme.color.bg.default};
  border: 1px solid ${({ theme }) => theme.color.border.default};
  border-radius: ${({ theme }) => theme.radius.base};
  box-shadow: ${({ theme }) => theme.shadow.sm};
  min-width: 180px;
  padding: 0;
  overflow: hidden;
`;
